import { getStore } from "store";
import { activeCompanyClear } from "actions/scope";

export default function (nextState, replace, callback) {
    const store = getStore();
    const { scope } = store.getState();
    if (scope.company && scope.company._id) {
        store.dispatch(activeCompanyClear());
    }
    callback();
}
